import React from 'react'
import {convertPrice} from '../../../functions/Functions'

function Account({lawyer_data}) {
  const {balance} = lawyer_data || ''
  
  if (balance)
  return (
    <div className="balance">
      <div className="current-balance">
        <span className="title">Stan Twojego konta wynosi:</span>
        <span className="balance-amount">{convertPrice(balance)} zł</span>
      </div>
      <a href="/prawnik-portfel/wyplac/" className="btn btn-blue btn-take-out">Wypłać pieniądze</a>
    </div>
  )
}

export default Account